import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Базовый',
  price: '$40',
  period: '/ мес.',
  isCurrent: false
}, {
  name: 'Стандарт',
  price: '$100',
  period: '/ 3 мес.',
  isCurrent: true
}, {
  name: 'Премиум',
  price: '$300',
  period: '/ год',
  isCurrent: false
}];
const paymentHistory = [{
  id: '1',
  date: '15 декабря 2025',
  amount: '$100',
  status: 'Оплачено'
}, {
  id: '2',
  date: '15 сентября 2025',
  amount: '$100',
  status: 'Оплачено'
}, {
  id: '3',
  date: '15 июня 2025',
  amount: '$100',
  status: 'Оплачено'
}];
export function SubscriptionScreen() {
  return <div className="min-h-screen bg-svt-bg" data-id="element-339">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-svt-bg/80 backdrop-blur-xl border-b border-svt-border transition-colors duration-300" data-id="element-340">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-341">
          <h1 className="text-2xl font-bold text-svt-text" data-id="element-342">Подписка</h1>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-6 space-y-6" data-id="element-343">
        {/* Current Plan Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="relative rounded-3xl overflow-hidden bg-svt-card border border-svt-border p-6" data-id="element-344">
          <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-primary opacity-10 blur-3xl rounded-full" data-id="element-345"></div>

          <div className="relative" data-id="element-346">
            <div className="flex items-start justify-between mb-4" data-id="element-347">
              <div data-id="element-348">
                <h2 className="text-xl font-bold text-svt-text mb-1" data-id="element-349">
                  Текущий план
                </h2>
                <p className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-350">
                  Стандарт
                </p>
              </div>
              <div className="px-3 py-1.5 rounded-full bg-green-500/20 border border-green-500/30 text-green-400 text-xs font-bold" data-id="element-351">
                Активна
              </div>
            </div>

            <div className="flex items-baseline gap-2 mb-2" data-id="element-352">
              <span className="text-3xl font-bold text-svt-text" data-id="element-353">$100</span>
              <span className="text-svt-text-muted" data-id="element-354">/ 3 месяца</span>
            </div>

            <p className="text-sm text-svt-text-muted" data-id="element-355">
              Действует до{' '}
              <span className="text-svt-text font-medium" data-id="element-356">15 марта 2026</span>
            </p>
          </div>
        </motion.div>

        {/* Plan Options */}
        <div data-id="element-357">
          <h3 className="text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-4" data-id="element-358">
            Доступные тарифы
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-359">
            {plans.map((plan, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1 + index * 0.05
          }} className={`relative p-6 rounded-2xl flex flex-col transition-all duration-300 ${plan.isCurrent ? 'bg-svt-card-highlight border border-svt-pink/40 shadow-[0_0_20px_rgba(232,67,147,0.1)]' : 'bg-svt-card-alt border border-svt-border hover:border-svt-border-hover'}`} data-id="element-360">
                <div className="flex items-center justify-between mb-4" data-id="element-361">
                  <h4 className="text-lg font-bold text-svt-text" data-id="element-362">
                    {plan.name}
                  </h4>
                  {plan.isCurrent && <div className="w-6 h-6 rounded-full bg-gradient-primary flex items-center justify-center" data-id="element-363">
                      <Check size={14} className="text-white" data-id="element-364" />
                    </div>}
                </div>

                <div className="flex items-baseline gap-1 mb-6" data-id="element-365">
                  <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-366">
                    {plan.price}
                  </span>
                  <span className="text-svt-text-muted" data-id="element-367">{plan.period}</span>
                </div>

                <button disabled={plan.isCurrent} className={`w-full py-3 rounded-full font-medium transition-all duration-300 ${plan.isCurrent ? 'bg-svt-surface text-svt-text-muted cursor-not-allowed' : 'border border-svt-pink/50 text-svt-pink-light hover:bg-svt-pink/10 hover:border-svt-pink'}`} data-id="element-368">
                  {plan.isCurrent ? 'Текущий' : 'Выбрать'}
                </button>
              </motion.div>)}
          </div>
        </div>

        {/* Payment History */}
        <div data-id="element-369">
          <h3 className="text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-4" data-id="element-370">
            История платежей
          </h3>
          <div className="space-y-3" data-id="element-371">
            {paymentHistory.map((payment, index) => <motion.div key={payment.id} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.3,
            delay: 0.3 + index * 0.05
          }} className="p-4 rounded-2xl bg-svt-surface border border-svt-border flex items-center justify-between" data-id="element-372">
                <div data-id="element-373">
                  <p className="text-sm font-medium text-svt-text mb-1" data-id="element-374">
                    {payment.date}
                  </p>
                  <p className="text-xs text-svt-text-muted" data-id="element-375">
                    {payment.status}
                  </p>
                </div>
                <div className="text-lg font-bold text-svt-text" data-id="element-376">
                  {payment.amount}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}